import IconChevronRight from './IconChevronRight'

export default IconChevronRight